import {
	BCInputMask,
	BCInputRef,
	IInputChangeEventArgs,
	IInputMaskProps
} from '@bimser/components';
import { FormItemTypes, IDictionary } from '@bimser/core';
import React from 'react';
import { IPropertyField, SizeType } from '../../../../entities/common';
import EditControl from '../../../runtime/base/EditControl';
import { IMaskInputProperties } from '././entities/IMaskInputProperties';
import Styles from './assets/style.scss';
import IFormatChar from './entities/IFormatChar';

export default class MaskInput extends EditControl<string> {
	mask: string = '';
	formatChars: IFormatChar[];
	sizeType: SizeType;
	inputRef = React.createRef<BCInputRef>();

	constructor() {
		super();

		this.controlType = FormItemTypes.EControlTypes.MaskInput;

		this.getFormatChars = this.getFormatChars.bind(this);
		this.triggerValueChanged = this.triggerValueChanged.bind(this);

		this.formatChars = [];

		this.subscribe('trigger:OnValueChanged', (value: string) => {
			this.triggerValueChanged({ data: value });
		});
	}

	__loadProperties(data: IMaskInputProperties) {
		super.__loadProperties(data);

		this.__proxyChanged.mask = data.mask;
		this.__proxyChanged.formatChars = data.formatChars;
		this.__proxyChanged.sizeType = data.sizeType;
	}

	private triggerValueChanged(args: IInputChangeEventArgs) {
		this.set('value', args.data);
	}

	private getFormatChars() {
		const formatChars: IDictionary<string> = {};

		this.formatChars?.forEach(f => {
			formatChars[f.text] = f.value || '';
		});

		return formatChars;
	}

	__getPropertyFields(): IPropertyField[] {
		const fields = super.__getPropertyFields();
		return [
			...fields,
			{
				name: 'value',
				type: 'string',
				common: true
			},
			{
				name: 'mask',
				type: 'string',
				common: true
			}
		];
	}

	focus(options?: { cursor?: 'start' | 'end' | 'all'; preventScroll?: boolean }) {
		this.inputRef.current?.focus(options);
	}

	__getComponentData(): IInputMaskProps & IDictionary<any> {
		return {
			...super.__getComponentData(),
			mask: this.mask,
			formatChars: this.formatChars,
			sizeType: this.sizeType,
			disabled: this.__isDisabled()
		};
	}

	__getSizeType() {
		return this.sizeType ?? this.__form.sizeType;
	}

	__render() {
		return super.__render(
			<BCInputMask
				ref={this.inputRef}
				tabIndex={this.tabIndex}
				formatChars={this.getFormatChars()}
				mask={this.mask}
				maxLength={this.mask ? undefined : 0}
				placeHolder={this.placeholder.getText()}
				value={this.value || this.text}
				onChange={this.triggerValueChanged}
				style={this.style}
				disabled={this.__isDisabled()}
				readOnly={this.__isReadOnly()}
				className={Styles.transparentContent}
				size={this.__getSizeType()}
				textAlign={this.textAlign}
			/>
		);
	}
}
